import { EnvironmentProviders, Provider, importProvidersFrom } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { HammerModule } from '@angular/platform-browser';

import { ROUTE_PROCESSOR } from '@frontend/vanilla/core';

import {
    provideBingoBootstrap,
    provideCasinoAppBootstrap,
    provideCasinoInstaSection,
    provideCasinoMenuActionsBootstrap,
    provideGeoCoordinator,
    provideGlobalSearchBootstrap,
    provideNativeBootstrap,
} from '../bootstrap/casino-app-bootstrap.provider';
import { CasinoLazyBootstrapService } from './bootstrap/casino-lazy-bootstrap.service';
import { CasinoRouteProductProcessor } from './casino-route-product-processor';

export function provideCasinoHostApp(): (Provider | EnvironmentProviders)[] {
    return [
        // Host-App specific
        CasinoLazyBootstrapService,
        {
            provide: ROUTE_PROCESSOR,
            useClass: CasinoRouteProductProcessor,
            multi: true,
        },
        importProvidersFrom(HammerModule),
        importProvidersFrom(MatDialogModule),
        provideCasinoAppBootstrap(),
        provideCasinoMenuActionsBootstrap(),

        provideNativeBootstrap(),
        provideBingoBootstrap(),
        provideGlobalSearchBootstrap(),
        provideGeoCoordinator(),

        provideCasinoInstaSection(),
    ];
}
